import React, {useState}  from "react";
import './news.css';
import NewsPreview from "./preview";
import { BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill} from "react-icons/bs";

import allPosts from "../../content/blog/posts.generated.json";

const News = ({ posts }) => {

    // Defaults to every post; the front page passes in only the highlights.
    const news = posts || allPosts;

    const [index, setIndex] = useState(1);

    let min_index = 0;
    let max_index = (news.length - 1);
    let index_can_decrease = index > min_index;
    let index_can_increase = index < max_index;

    // Always show a window of three previews, clamped to the ends of the list,
    // so the initial view (and the first/last positions) still show three bubbles.
    const WINDOW = 3;
    let start = Math.max(0, Math.min(index - 1, news.length - WINDOW));
    let end = Math.min(news.length, start + WINDOW);

    let selected_news = news.slice(start, end)

    function decrease_index(){
        setIndex(Math.max(index - 1, min_index));
    }

    function increase_index(){
        setIndex(Math.min(index + 1, max_index));
    }

    return (
        <div className="news">
            <BsFillArrowLeftCircleFill onClick={decrease_index} className={
                index_can_decrease ? "nav-button nav-button-left" : "nav-button-inactive"
                }></BsFillArrowLeftCircleFill>
            <div className="news-previews">
                {
                    selected_news.map((n, idx) => {
                        return (
                            <NewsPreview 
                                title={n.title}
                                date={n.date}
                                place={n.place}
                                description={n.body}
                                image={n.image}
                                type={(start + idx) === index ? "current": (start + idx) < index ? "previous" : "next"}
                            ></NewsPreview>
                        )
                    })
                }
            </div>
            <BsFillArrowRightCircleFill onClick={increase_index} className={
                index_can_increase ? "nav-button nav-button-right" : "nav-button-inactive"
                }></BsFillArrowRightCircleFill>
            <div className="indicators">
                {
                    news.map( (_, idx) => {
                        return (<div className={ idx === index ? "indicator indicator-active" : "indicator"}></div>);
                    })
                }
            </div>
        </div>
    )
};


export default News